import { render, staticRenderFns } from "./AdminProjectPosts.vue?vue&type=template&id=067996f3&"
import script from "./AdminProjectPosts.vue?vue&type=script&lang=js&"
export * from "./AdminProjectPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports